import spinner from "./spinner.gif"

function Spinner() {
  return <image src={spinner} alt="Loading..." style={{width: "100px", margin: "auto", display: "block"}}/>
}

export default Spinner;
